export enum SyncVerb {
	Add = 'add',
	Remove = 'remove',
	Update = 'update'
}
